export default __webpack_public_path__ + "static/media/paso26.0ada171f.png";